
export const ReportResponseStatus = {
    'ACPT': 'Accepted',
    'ACPD': 'Accepted after pending',
    'PDNG': 'Pending',
    'RJCT': 'Rejected',
    'RJPD': 'Rejected after pending',
    'RCVD': 'Received',
    'WARN': 'Warning',
}